"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareCertifcateDownloadSchema = exports.NotesCeritifcateConfigSchema = exports.ShareCeritifcateConfigSchema = exports.CertificateOfficeholderSchema = void 0;
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
const START_NUMBER_MAX_LENGTH = "number can not exceed 8 digits";
exports.CertificateOfficeholderSchema = {
    officeholders: yup.array().of(yup.object().shape({
        _id: yup.string().required("This is a required field"),
        fontFamily: yup.lazy((fontFamily) => fontFamily === null ? yup.string().nullable() : yup.string().required("This is a required field")),
    })),
};
exports.ShareCeritifcateConfigSchema = yup.object().shape({
    prefix: yup
        .string()
        .required("Please enter a prefix")
        .matches(constants_1.ALPHANUMERIC_REGEX, "Prefix must contain only letters and numbers")
        .min(2, "Prefix should be at least 2 characters")
        .max(4, "Prefix can not exceed 4 characters"),
    startNumber: yup.lazy((startNumber) => startNumber === "" || startNumber === undefined
        ? yup.string().required("Please enter a number")
        : yup
            .number()
            .typeError("Only number values can be entered")
            .test("maximum 8 digits", START_NUMBER_MAX_LENGTH, () => startNumber.toString().length < 9)
            .when("$highestNumber", ([highestNumber], schema) => highestNumber !== 0
            ? schema.min(highestNumber + 1, `Start number should be greater than ${highestNumber}`)
            : schema.min(1, "Start number should be 1 or greater"))),
    officeholders: exports.CertificateOfficeholderSchema.officeholders,
});
exports.NotesCeritifcateConfigSchema = yup.object().shape({
    officeholders: exports.CertificateOfficeholderSchema.officeholders,
});
exports.ShareCertifcateDownloadSchema = yup.object().shape({
    downloadType: yup.string().required("Please select a download type"),
    downloadFrom: yup
        .number()
        .when(["$highestNumber", "downloadType", "downloadTo"], ([highestNumber, downloadType, downloadTo], schema) => downloadType === "range"
        ? schema
            .typeError("Please enter a number")
            .required("Please enter a start number")
            .test("max limit", "cannot be greater than highest certificate number", (downloadFrom) => downloadFrom < highestNumber)
            .test("max limit", "cannot be greater than end number", (downloadFrom) => {
            if (downloadTo !== undefined)
                return downloadFrom < downloadTo;
            return true;
        })
        : schema.notRequired()),
    downloadTo: yup
        .number()
        .when(["$highestNumber", "downloadType", "downloadFrom"], ([highestNumber, downloadType, downloadFrom], schema) => downloadType === "range"
        ? schema
            .typeError("Please enter a number")
            .required("Please enter a end number")
            .test("max limit", "cannot be greater than highest certificate number", (downloadTo) => downloadTo <= highestNumber)
            .test("max limit", "cannot be less than start number", (downloadTo) => {
            if (downloadFrom !== undefined)
                return downloadTo > downloadFrom;
            return true;
        })
        : schema.notRequired()),
}, [["downloadFrom", "downloadTo"]]);
//# sourceMappingURL=CertifcateConfigSchema.js.map